import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { SharedModule } from '../shared.module';
import { catchError, map } from 'rxjs/operators';

//SERVICES
import { ConfigService } from '../services/config.service';

//MODELS
import { ProductPricingOption } from '../models/product-pricing-option.interface';
import { Observable, of, Subscriber } from 'rxjs';
import { CompassApiResponse } from '../models/compass-api-response.interface';
import { CompassApiStatusEnum } from '../models/compass-api-status-enum';
import { CompassApiGetResults } from '../models/compass-api-get-results.interface';


@Injectable({providedIn: SharedModule})
export class CompassAPIProductPricingOptionsService {

	public params = new URLSearchParams();
	public config: any;
	public baseUrl: string;

	constructor(
		private httpClient: HttpClient,
		private _configService: ConfigService
	) { 

		this.config = this._configService.getCompassApi();
		//console.log('this.config:', this.config);
		this.baseUrl = this.config.baseUrl + 'productpricingoptions';
	}


	/**
	 * Get Product Pricing Options
	 * @param productId 
	 * @param limit 
	 * @param offset 
	 * @param sortBy 
	 * @param sortDirection 
	 * @returns 
	 */
	public getProductPricingOptions (productId: string, limit: number = null, offset: number = null, sortBy: string = null, sortDirection: string = null): Observable<CompassApiGetResults>{
		let url = new URL(this.baseUrl);
		if(productId) url.searchParams.append('productId', String(productId));
		if(limit) url.searchParams.append('limit', String(limit));
		if(offset) url.searchParams.append('offset', String(offset));
		if(sortBy) url.searchParams.append('sortBy', sortBy);
		if(sortDirection)  url.searchParams.append('sortDirection', sortDirection);
		//console.log('API.getProductPricingOptions().url', url);

		return this.httpClient
			.get(String(url), { headers: this.config.headers })
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.getProductPricingOptions.res:', res);
				if(res.status == CompassApiStatusEnum.ok && res.total > 0) {
					const getResults: CompassApiGetResults = {
						total: res.total,
						results: res.results
					}
					return getResults;
				} else {
					return null;
				}
			}));
	}



	/**
	 * Get Product by ID 
	 * @param id 
	 * @returns 
	*/
	public getProductPricingOptionById (id: string): Observable<ProductPricingOption>{
		let url = new URL(this.baseUrl + '/' + id);
		//url.searchParams.append('RequestSiteContext', this.config.RequestSiteContext);
		//console.log('API.getProductPricingOptionById().url:', String(url));

		return this.httpClient
			.get(String(url), { headers: this.config.headers })
			.pipe(
				catchError(err => of({"error": err}))//.error
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.getProductPricingOptionById.res:', res);
				//console.log('API.getProductPricingOptionById.res:', JSON.stringify(res));
				if(res.status == CompassApiStatusEnum.ok) {
					const option: ProductPricingOption = res.result;
					return option;
				} else {
					return res;
				}
			}));
	}


	public getProductPricingOptionByIdPromise(id: string): Promise<ProductPricingOption|null>{
		//console.log('API.getProductPricingOptionByIdPromise.id:', id);
		return this.getProductPricingOptionById(id).toPromise().then(res => (res as ProductPricingOption).id?res:null);
	}



	/**
	 * Post (create) ProductPricingOption
	 * @param data:ProductPricingOption
	 * @returns 
	*/
	public postProductPricingOption (data: ProductPricingOption){
		let url = this.baseUrl,
			body = data,
			options = { 
				headers: this.config.headers,
			};
		// console.log('API.postProductPricingOption().url', url);
		// console.log('API.postProductPricingOption().body', body);
		// console.log('API.postProductPricingOption().options', options);

		return this.httpClient
			.post(url, body, options)
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.postProductPricingOption.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return res.result;
				} else { 
					return res;//uses error
				}
			}));
	}




	/**
	 * PUT (update) ProductPricingOption
	 * @param data:ProductPricingOption
	 * @returns 
	*/
	public putProductPricingOption (id: string, data: ProductPricingOption){
		let url = this.baseUrl + '/' + id,
			body = data,
			options = { 
				headers: this.config.headers,
			};
		// console.log('API.putProductPricingOption().url', url);
		// console.log('API.putProductPricingOption().body', body);
		// console.log('API.putProductPricingOption().options', options);

		return this.httpClient
			.put(url, body, options)
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.postProductPricingOption.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return res.result;
				} else { 
					return res;//uses error
				}
			}));
	}




	/**
	 * Delete ProductPricingOption
	 * @param id 
	 * @returns 
	 */
	 public deleteProductPricingOption (id: string){
		let url = this.baseUrl + '/' + id,
		options = { 
			headers: this.config.headers,
		};
		//console.log('API.deleteProductPricingOption().url', url);
		return this.httpClient
			.delete(url, options)
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.deleteProductPricingOption.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return res.result;
				} else { 
					return res;
				}
			}));
	}

}